import BankWatchUserService from '@/services/bankwatch/UserService';

const bankwatchUserService = new BankWatchUserService();

export const getAllUsers = async({ commit }: {commit: Function}) => {
    commit('isFetching', true);
    const users = await bankwatchUserService.getAllUsers();
    commit('allUsers', users);
    commit('isFetching', false);
}

export const deactivateUser = async({ commit }: {commit: Function}, userId: string) => {
    await bankwatchUserService.deactivateUser(userId);
}

export const saveUser = async({ commit }: { commit: Function }, payload: any) => {
    await bankwatchUserService.saveUser(payload.userId, payload.user);
}
